export default __webpack_public_path__ + "c0987dfdb60d8f18b5cc512f8a320d94.png";